import { useSelector } from "react-redux";
export const useAuth = () => {
	const { user: userData } = useSelector((state) => state.auth);

	return {
		userData,
	};
};
